import React from "react"
import autobind from "class-autobind"
import strings from "../../localization/strings"
import EmployeeChip from "../../components/employee/EmployeeChip"
import { Dialog, FlatButton, SelectField, MenuItem, TextField, FontIcon, Toggle } from "material-ui"
import { IUIUser, ITimeoffRequestDocument, IUserDocument, IEmployeeAccrual, ETimeoffStatus, ETimeoffValidationType, ELoggedInUserType, EDayOfWeek } from "../../models"
import AccountStore from "../../stores/AccountStore"
import AuthenticationStore from "../../stores/AuthenticationStore"
import moment from "moment"
import * as utils from "../../helpers/utils"
import * as api from "../../api"
import { red500, blueGrey500 } from "material-ui/styles/colors"
import * as payGroupAndTypeHelper from "../../helpers/payGroupAndTypeHelper"
import FinddDatePicker from "../common/FinddDatePicker"
import SpecifyDays from "../common/SpecifyDays"
import * as timeHelper from "../../helpers/timeHelper"
import * as permissionHelper from "../../helpers/permissionHelper"

interface IProps {
	editLeaveRequest: ITimeoffRequestDocument
	handleClose(): void
	handleAdd(leaveRequest: ITimeoffRequestDocument, successMessage: string): Promise<ETimeoffValidationType>
	handleUpdate(leaveRequest: ITimeoffRequestDocument, successMessage: string): Promise<ETimeoffValidationType>
	readonly: boolean
	// for user detail -> leave tracking
	employee?: IUserDocument
	loggedInUserType?: ELoggedInUserType
}
interface IState {
	errEmployee: boolean
	employee: IUserDocument
	selectedEmployeeAccrual: IEmployeeAccrual
	errorSelectedEmployeeAccrual: string
	title: string
	hoursPerDay: number
	selectedStatus: ETimeoffStatus
	startDate: string
	errorStartDate: string
	endDate: string
	errorEndDate: string
	comments: string
	saving: boolean
	errorSaving: string
	enableSpecifyDays: boolean
	specifyDays: EDayOfWeek[]
	errorSpecifyDays: string
	errorComment: string
	payRate: number
	errorPayRate: string
}

export default class AddLeaveRequestDialog extends React.Component<IProps, IState> {
	private StartDate
	private EndDate
	private changedStartDate: boolean = false
	constructor(props: IProps) {
		super(props)
		this.state = {
			errEmployee: false,
			employee: props.employee ? props.employee : null,
			selectedEmployeeAccrual: props.employee && props.editLeaveRequest ? props.employee.Accruals.find(item => item.Id === props.editLeaveRequest.AccrualId) : null,
			errorSelectedEmployeeAccrual: "",
			title: props.editLeaveRequest ? props.editLeaveRequest.Description : null,
			hoursPerDay: props.editLeaveRequest ? props.editLeaveRequest.HoursPerDay : 8,
			selectedStatus: props.editLeaveRequest ? props.editLeaveRequest.Status : ETimeoffStatus.Requested,
			startDate: props.editLeaveRequest ? props.editLeaveRequest.StartDate : null,
			errorStartDate: "",
			endDate: props.editLeaveRequest ? props.editLeaveRequest.EndDate : null,
			errorEndDate: "",
			comments: "",
			payRate: props.editLeaveRequest ? props.editLeaveRequest.PayRate : null,
			saving: false,
			errorSaving: "",
			enableSpecifyDays: props.editLeaveRequest && props.editLeaveRequest.SpecifyDays && props.editLeaveRequest.SpecifyDays.length > 0,
			specifyDays: props.editLeaveRequest && props.editLeaveRequest.SpecifyDays ? props.editLeaveRequest.SpecifyDays : [],
			errorSpecifyDays: "",
			errorComment: "",
			errorPayRate: ""
		}
		autobind(this)
	}

	componentDidMount() {
		!this.props.employee && this.props.editLeaveRequest &&
			this.getEmployeeData()
	}

	getEmployeeData() {
		api.getUser(this.props.editLeaveRequest.UserId).then(res => {
			this.setState({
				employee: res.data,
				selectedEmployeeAccrual: res.data.Accruals.find(item => item.Id === this.props.editLeaveRequest.AccrualId)
			})
		})
	}

	handleAdd(leaveRequest: ITimeoffRequestDocument, successMessage: string) {
		this.setState({ saving: true }, () =>
			this.props.handleAdd(leaveRequest, successMessage).then(res => {
				this.setState({ saving: false })
				switch (res) {
					case ETimeoffValidationType.None:
						this.props.handleClose()
						break
					case ETimeoffValidationType.BalanceError:
						this.setState({ errorSaving: strings.Not_enough_hours_available_to_make_this_leave_request })
						break
					case ETimeoffValidationType.DateRangeError:
						this.setState({ errorSaving: strings.Cannot_make_Leave_Request_for_locked_pay_period })
						break
					case ETimeoffValidationType.DuplicatedDateError:
						this.setState({ errorSaving: strings.Leave_Request_exist_for_selected_period })
						break
					case ETimeoffValidationType.ProhibitionEndDateError:
						this.setState({ errorSaving: strings.Leave_request_should_not_be_created_with_a_date_that_is_before_the_prohibition_end_date })
						break
					case ETimeoffValidationType.MaxPunchSetLengthError:
						this.setState({ errorSaving: strings.formatString(strings.Hours_Per_Day_cannot_greather_than_x, payGroupAndTypeHelper.getPayGroupByPayrollPayGroupData({ PayrollHierarchyItemId: this.state.employee.PayrollHierarchyItemId, PayrollPayGroupId: this.state.employee.PayrollPayGroupId }).PaySettings.MaximumPunchSetLength) as string })
						break
					case ETimeoffValidationType.PayTypeError:
						this.setState({ errorSaving: strings.The_PayType_of_leave_request_invalid_for_employee })
						break
					case ETimeoffValidationType.LockedError:
						this.setState({ errorSaving: strings.Cannot_make_Locked_Leave_Request })
						break
					case ETimeoffValidationType.EmployeeInactive:
						this.setState({ errorSaving: strings.Cannot_add_Leave_Request_for_Inactive_Employee })
						break
				}
			})
		)
	}

	handleUpdate(leaveRequest: ITimeoffRequestDocument, successMessage: string) {
		this.setState({ saving: true }, () =>
			this.props.handleUpdate(leaveRequest, successMessage).then(res => {
				this.setState({ saving: false })
				switch (res) {
					case ETimeoffValidationType.None:
						this.props.handleClose()
						break
					case ETimeoffValidationType.BalanceError:
						this.setState({ errorSaving: strings.Not_enough_hours_available_to_make_this_leave_request })
						break
					case ETimeoffValidationType.DateRangeError:
						this.setState({ errorSaving: strings.Cannot_update_Leave_Request_for_locked_pay_period })
						break
					case ETimeoffValidationType.DuplicatedDateError:
						this.setState({ errorSaving: strings.Leave_Request_exist_for_selected_period })
						break
					case ETimeoffValidationType.ProhibitionEndDateError:
						this.setState({ errorSaving: strings.Leave_request_should_not_be_created_with_a_date_that_is_before_the_prohibition_end_date })
						break
					case ETimeoffValidationType.MaxPunchSetLengthError:
						this.setState({ errorSaving: strings.formatString(strings.Hours_Per_Day_cannot_greather_than_x, payGroupAndTypeHelper.getPayGroupByPayrollPayGroupData({ PayrollHierarchyItemId: this.state.employee.PayrollHierarchyItemId, PayrollPayGroupId: this.state.employee.PayrollPayGroupId }).PaySettings.MaximumPunchSetLength) as string })
						break
					case ETimeoffValidationType.PayTypeError:
						this.setState({ errorSaving: strings.The_PayType_of_leave_request_invalid_for_employee })
						break
					case ETimeoffValidationType.LockedError:
						this.setState({ errorSaving: strings.Cannot_update_Locked_Leave_Request })
						break
					case ETimeoffValidationType.EmployeeInactive:
						this.setState({ errorSaving: strings.Cannot_add_Leave_Request_for_Inactive_Employee })
						break
					case ETimeoffValidationType.PermissionError:
						this.setState({ errorSaving: strings.You_have_not_permission })
						break
				}
			})
		)
	}

	checkValidate() {
		let isValidate = true
		if (!this.state.employee) {
			this.setState({ errEmployee: true })
			isValidate = false
		}
		else {
			this.setState({ errEmployee: false })
		}

		if (!this.state.selectedEmployeeAccrual) {
			this.setState({ errorSelectedEmployeeAccrual: strings.This_field_is_required })
			isValidate = false
		}
		else {
			this.setState({ errorSelectedEmployeeAccrual: "" })
		}

		if (!this.state.startDate) {
			this.setState({ errorStartDate: strings.This_field_is_required })
			isValidate = false
		}
		else if (this.state.selectedEmployeeAccrual &&
			this.state.selectedEmployeeAccrual.EnableProbationDate &&
			this.state.selectedEmployeeAccrual.AccrualEndProbationDate &&
			moment(this.state.selectedEmployeeAccrual.AccrualEndProbationDate).isAfter(moment(this.state.startDate))) {
			this.setState({ errorStartDate: strings.formatString(strings.Cannot_add_before_probation_end_date, moment(this.state.selectedEmployeeAccrual.AccrualEndProbationDate).subtract(moment().utcOffset(), "minutes").format("MM/DD/YYYY")) as string })
			isValidate = false
		}
		else {
			this.setState({ errorStartDate: "" })
		}

		if (!this.state.endDate) {
			this.setState({ errorEndDate: strings.This_field_is_required })
			isValidate = false
		}
		else if (this.state.startDate && moment(this.state.startDate).isAfter(moment(this.state.endDate))) {
			this.setState({ errorEndDate: strings.Invalid_date_range })
			isValidate = false
		}
		else {
			this.setState({ errorEndDate: "" })
		}

		if (this.state.selectedStatus === ETimeoffStatus.Approved && !this.state.comments) {
			const accrualToCheck = AccountStore.getCurrentAccount().Accruals.find((accrual) => accrual.Id === this.state.selectedEmployeeAccrual.LinkedAccountAccrualId)
			if (accrualToCheck && accrualToCheck.RequireNoteOnTimeOffApproval) {
				this.setState({ errorComment: strings.This_field_is_required })
				isValidate = false
			} else {
				this.setState({ errorComment: "" })
			}
		} else {
			this.setState({ errorComment: "" })
		}

		if (this.state.startDate && this.state.endDate && this.state.enableSpecifyDays && this.state.specifyDays.length > 0) {
			const dayOfWeekArray = timeHelper.getDayOfWeekArrayByDateRange(timeHelper.keepConvertUTCToLocal(this.state.startDate), timeHelper.keepConvertUTCToLocal(this.state.endDate))
			if (this.state.specifyDays.findIndex(i => !dayOfWeekArray.includes(i)) > -1) {
				this.setState({ errorSpecifyDays: strings.Not_match_days })
				isValidate = false
			}
			else {
				this.setState({ errorSpecifyDays: "" })
			}
		}
		else {
			this.setState({ errorSpecifyDays: "" })
		}

		if (this.state.payRate) {
			const userAccrual = this.props.employee.Accruals.find((accrual) => accrual.Id === this.state.selectedEmployeeAccrual.Id)
			const account = AccountStore.getCurrentAccount()

			if (userAccrual) {
				const accountAccrual = account.Accruals.find((accrual) => accrual.Id === userAccrual.LinkedAccountAccrualId)
				if (accountAccrual) {
					const payType = account.PayTypes.find((paytype) => paytype.Id === accountAccrual.PayTypeIdUsedForLeavePunchSet)
					if (payType && !payType.PaidTime) {
						this.setState({ errorPayRate: strings.Pay_Rate_cannot_entered_for_this_request_as_this_is_not_paid_leave })
						isValidate = false
					} else {
						this.setState({ errorPayRate: "" })
					}
				}
			}
		} else {
			this.setState({ errorPayRate: "" })
		}

		this.setState({ errorSaving: "" })
		return isValidate
	}

	handleSavePendingStatus() {
		if (!this.checkValidate()) return
		if (this.props.editLeaveRequest) {
			const payload = Object.assign({}, this.props.editLeaveRequest)
			payload.Description = this.state.title ? this.state.title.trim() : null
			payload.StartDate = this.state.startDate
			payload.EndDate = this.state.endDate
			payload.HoursPerDay = this.state.hoursPerDay
			payload.AccrualId = this.state.selectedEmployeeAccrual.Id
			payload.AccrualName = this.state.selectedEmployeeAccrual.Name
			payload.Status = ETimeoffStatus.Requested
			payload.SpecifyDays = this.state.enableSpecifyDays ? this.state.specifyDays : []
			payload.PayRate = this.state.payRate ? this.state.payRate : 0
			this.state.comments.trim() &&
				payload.Notes.push({
					Note: this.state.comments.trim(),
					DateTime: moment().utc().format(),
					UserId: AuthenticationStore.getCookieUserId(),
					UserName: `${AuthenticationStore.getLoggedInUser().FirstName} ${AuthenticationStore.getLoggedInUser().LastName}`,
					StatusAssociatedWithNote: ETimeoffStatus.Requested
				})

			this.handleUpdate(payload, strings.Leave_request_updated_successfully)
		}
		else {
			const payload: ITimeoffRequestDocument = {
				Id: utils.guid(),
				AccountId: AccountStore.getCurrentAccount().Id,
				UserId: this.state.employee.Id,
				UserDefaultHierarchyItemId: this.state.employee.DefaultPunchHierarchyId,
				UserDefaultJobId: this.state.employee.DefaultJobId,
				Description: this.state.title ? this.state.title.trim() : null,
				StartDate: this.state.startDate,
				EndDate: this.state.endDate,
				HoursPerDay: this.state.hoursPerDay,
				Status: ETimeoffStatus.Requested,
				AccrualId: this.state.selectedEmployeeAccrual.Id,
				AccrualName: this.state.selectedEmployeeAccrual.Name,
				EmployeeName: `${this.state.employee.FirstName} ${this.state.employee.LastName}`,
				EmployeeExternalId: this.state.employee.ExternalId,
				SpecifyDays: this.state.enableSpecifyDays ? this.state.specifyDays : [],
				PayRate: this.state.payRate ? this.state.payRate : 0,
				Notes: this.state.comments.trim() ?
					[{
						Note: this.state.comments.trim(),
						DateTime: moment().utc().format(),
						UserId: AuthenticationStore.getCookieUserId(),
						UserName: `${AuthenticationStore.getLoggedInUser().FirstName} ${AuthenticationStore.getLoggedInUser().LastName}`,
						StatusAssociatedWithNote: ETimeoffStatus.Requested
					}] :
					null,
			}
			this.handleAdd(payload, strings.Leave_request_saved_successfully)
		}
	}

	handleSaveApproveStatus() {
		if (!this.checkValidate()) return
		if (this.props.editLeaveRequest) {
			const payload = Object.assign({}, this.props.editLeaveRequest)
			payload.Description = this.state.title ? this.state.title.trim() : null
			payload.StartDate = this.state.startDate
			payload.EndDate = this.state.endDate
			payload.HoursPerDay = this.state.hoursPerDay
			payload.AccrualId = this.state.selectedEmployeeAccrual.Id
			payload.AccrualName = this.state.selectedEmployeeAccrual.Name
			payload.Status = ETimeoffStatus.Approved
			payload.SpecifyDays = this.state.enableSpecifyDays ? this.state.specifyDays : []
			payload.PayRate = this.state.payRate ? this.state.payRate : 0
			payload.Notes.push({
				Note: this.state.comments ? this.state.comments : strings.Approve,
				DateTime: moment().utc().format(),
				UserId: AuthenticationStore.getCookieUserId(),
				UserName: `${AuthenticationStore.getLoggedInUser().FirstName} ${AuthenticationStore.getLoggedInUser().LastName}`,
				StatusAssociatedWithNote: ETimeoffStatus.Approved
			})

			this.handleUpdate(payload, strings.Leave_request_updated_and_approved_successfully)
		}
		else {
			const payload: ITimeoffRequestDocument = {
				Id: utils.guid(),
				AccountId: AccountStore.getCurrentAccount().Id,
				UserId: this.state.employee.Id,
				UserDefaultHierarchyItemId: this.state.employee.DefaultPunchHierarchyId,
				UserDefaultJobId: this.state.employee.DefaultJobId,
				Description: this.state.title ? this.state.title.trim() : null,
				StartDate: this.state.startDate,
				EndDate: this.state.endDate,
				HoursPerDay: this.state.hoursPerDay,
				Status: ETimeoffStatus.Approved,
				AccrualId: this.state.selectedEmployeeAccrual.Id,
				AccrualName: this.state.selectedEmployeeAccrual.Name,
				EmployeeName: `${this.state.employee.FirstName} ${this.state.employee.LastName}`,
				EmployeeExternalId: this.state.employee.ExternalId,
				SpecifyDays: this.state.enableSpecifyDays ? this.state.specifyDays : [],
				PayRate: this.state.payRate ? this.state.payRate : 0,
				Notes: [{
					Note: this.state.comments ? this.state.comments : strings.Approve,
					DateTime: moment().utc().format(),
					UserId: AuthenticationStore.getCookieUserId(),
					UserName: `${AuthenticationStore.getLoggedInUser().FirstName} ${AuthenticationStore.getLoggedInUser().LastName}`,
					StatusAssociatedWithNote: ETimeoffStatus.Approved
				}]
			}
			this.handleAdd(payload, strings.Leave_request_saved_and_approved_successfully)
		}
	}

	handleSaveDenyStatus() {
		if (!this.checkValidate()) return
		const payload = Object.assign({}, this.props.editLeaveRequest)
		payload.Description = this.state.title ? this.state.title.trim() : null
		payload.StartDate = this.state.startDate
		payload.EndDate = this.state.endDate
		payload.HoursPerDay = this.state.hoursPerDay
		payload.AccrualId = this.state.selectedEmployeeAccrual.Id
		payload.AccrualName = this.state.selectedEmployeeAccrual.Name
		payload.Status = ETimeoffStatus.Denied
		payload.SpecifyDays = this.state.enableSpecifyDays ? this.state.specifyDays : []
		payload.PayRate = this.state.payRate ? this.state.payRate : 0
		payload.Notes.push({
			Note: this.state.comments ? this.state.comments : strings.Denied,
			DateTime: moment().utc().format(),
			UserId: AuthenticationStore.getCookieUserId(),
			UserName: `${AuthenticationStore.getLoggedInUser().FirstName} ${AuthenticationStore.getLoggedInUser().LastName}`,
			StatusAssociatedWithNote: ETimeoffStatus.Denied
		})
		this.handleUpdate(payload, strings.Leave_request_denied_successfully)
	}

	render() {
		const maxHoursPerDay = this.state.employee ? payGroupAndTypeHelper.getPayGroupByPayrollPayGroupData({ PayrollHierarchyItemId: this.state.employee.PayrollHierarchyItemId, PayrollPayGroupId: this.state.employee.PayrollPayGroupId }).PaySettings.MaximumPunchSetLength : 24
		const timeoffHoursStep = AccountStore.getOneHourTimeoffIncrement() ?
			1 :
			this.props.loggedInUserType === ELoggedInUserType.Employee ? 0.5 : 0.01
		return (
			<Dialog
				open
				autoScrollBodyContent
				title={this.props.editLeaveRequest ? strings.Edit_Leave_Request : strings.New_Leave_Request}
				titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
				actions={[
					<span style={{ fontSize: 19, marginRight: 40, color: red500 }}>
						{this.state.errorSaving}
					</span>,
					<FlatButton
						data-intercom-target={"LeaveTracking-Btn-CloseAddLeaveTrackingDialog"}
						label={strings.CANCEL}
						secondary
						disabled={this.state.saving}
						onClick={this.props.handleClose}
					/>,
					(!this.props.readonly && <FlatButton
						data-intercom-target={"LeaveTracking-Btn-SaveLeaveTracking"}
						label={strings.SAVE}
						primary
						disabled={this.state.saving}
						onClick={() =>
							this.state.selectedStatus === ETimeoffStatus.Requested ?
								this.handleSavePendingStatus() :
								this.state.selectedStatus === ETimeoffStatus.Approved ?
									this.handleSaveApproveStatus() :
									this.handleSaveDenyStatus()
						}
					/>)
				]}
			>
				<hr />
				<div style={{ display: "flex" }}>
					{!this.props.employee &&
						<div style={{ width: "50%", marginRight: "5%" }}>
							<EmployeeChip
								errEmployee={this.state.errEmployee}
								setEmployee={uiUser => {
									api.getUser(uiUser.Id).then(res =>
										this.setState({ employee: res.data, selectedEmployeeAccrual: null }, () => this.checkValidate())
									)
								}}
								filterByLevel={true}
								readonly={this.props.editLeaveRequest !== null}
								selectedEmployee={this.state.employee as IUIUser}
							/>
						</div>
					}
					<div style={{ position: "relative" }}>
						<SelectField
							data-intercom-target={"LeaveTracking-Select-Accrual"}
							floatingLabelText={strings.Accrual}
							value={this.state.selectedEmployeeAccrual}
							onChange={(e, key, payload) => this.setState({ selectedEmployeeAccrual: payload }, () => this.checkValidate())}
							errorText={this.state.errorSelectedEmployeeAccrual}
							errorStyle={{ position: "absolute", bottom: -10 }}
							disabled={this.props.readonly}
						>
							{this.state.employee && this.state.employee.Accruals
								.filter(item => !item.Deleted && item.Active && item.AllowUseForLeaveTracking)
								.map((item, key) => <MenuItem key={key} value={item} primaryText={item.Name} />)
							}
						</SelectField>
						{this.state.selectedEmployeeAccrual &&
							<span style={{ position: "absolute", width: 70, top: 40, color: "rgb(97, 97, 97)", marginLeft: 15, fontSize: 14 }}>
								{`${this.state.selectedEmployeeAccrual.PendingBalance} ${strings.Hours}`}
							</span>
						}
					</div>
				</div>
				<TextField
					data-intercom-target={"LeaveTracking-Entry-Description"}
					floatingLabelText={strings.Title}
					value={this.state.title}
					style={{ width: "90%" }}
					onChange={(e, value) => this.setState({ title: value })}
					disabled={this.props.readonly}
				/>
				<div style={{ display: "flex" }}>
					<div style={{ width: "50%", marginRight: "5%" }}>
						<TextField
							data-intercom-target={"LeaveTracking-Entry-HoursPerDay"}
							type="number"
							floatingLabelText={strings.Hours_Per_Day}
							value={this.state.hoursPerDay}
							step={timeoffHoursStep}
							inputStyle={{ appearance: "auto" }}
							onChange={(e, value) =>
								value >= timeoffHoursStep &&
								value <= maxHoursPerDay &&
								this.setState({
									hoursPerDay: AccountStore.getOneHourTimeoffIncrement() ?
										Math.round(value) :
										this.props.loggedInUserType === ELoggedInUserType.Employee ?
											Math.round(value * 2) / 2 :
											Math.round(value * 100) / 100
								})
							}
							disabled={this.props.readonly}
						/>
					</div>
					{this.props.loggedInUserType !== ELoggedInUserType.Employee &&
						(this.state.employee && this.state.employee.Id === AuthenticationStore.getLoggedInUser().Id ?
							permissionHelper.hasPermission(AuthenticationStore.Permissions.LeaveTracking.AllowSupervisorToApproveDenyOwnLeaveRequests) :
							true
						) &&
						<div>
							<SelectField
								data-intercom-target={"LeaveTracking-Select-Status"}
								floatingLabelText={strings.Status}
								value={this.state.selectedStatus}
								onChange={(e, key, payload) => this.setState({ selectedStatus: payload })}
								disabled={this.props.readonly}
							>
								<MenuItem value={ETimeoffStatus.Requested} primaryText={strings.Request} />
								<MenuItem value={ETimeoffStatus.Approved} primaryText={strings.Approve} />
								{this.props.editLeaveRequest &&
									<MenuItem value={ETimeoffStatus.Denied} primaryText={strings.Deny} />
								}
							</SelectField>
						</div>
					}
				</div>
				<div style={{ display: "flex" }}>
					<div style={{ width: "50%", marginRight: "5%", position: "relative" }}>
						<FinddDatePicker
							data-intercom-target={"LeaveTracking-Select-StartDate"}
							ref={(elem) => this.StartDate = elem}
							floatingLabelText={strings.Leave_Start_Date}
							formatDate={(date) => moment(date).format("MM/DD/YYYY")}
							onChange={(e, date) => {
								if (!this.changedStartDate) {
									this.changedStartDate = true
									this.setState({ startDate: moment(date).utc(true).startOf("day").format(), endDate: moment(date).utc(true).endOf("day").format() }, () => this.checkValidate())
								}
								else {
									this.setState({ startDate: moment(date).utc(true).startOf("day").format() }, () => this.checkValidate())
								}
							}}
							value={this.state.startDate && new Date(moment(this.state.startDate).local().subtract(moment(this.state.startDate).utcOffset(), "minutes").format())}
							errorText={this.state.errorStartDate}
							errorStyle={{ position: "absolute", bottom: -9, fontSize: 11 }}
							cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
							firstDayOfWeek={0}
							disabled={this.props.readonly}
						/>
						<FontIcon
							data-intercom-target={"LeaveTracking-Btn-StartDatePicker"}
							className="fa fa-calendar"
							style={{ position: "absolute", top: 35, right: 110, fontSize: 21, color: "rgba(97, 97, 97, 0.6)" }}
							onClick={() => this.StartDate.DatePicker.openDialog()}
						/>
					</div>
					<div style={{ position: "relative" }}>
						<FinddDatePicker
							data-intercom-target={"LeaveTracking-Select-EndDate"}
							ref={(elem) => this.EndDate = elem}
							floatingLabelText={strings.Leave_End_Date}
							formatDate={(date) => moment(date).format("MM/DD/YYYY")}
							onChange={(e, date) => this.setState({ endDate: moment(date).utc(true).endOf("day").format() }, () => this.checkValidate())}
							value={this.state.endDate && new Date(moment(this.state.endDate).local().subtract(moment(this.state.endDate).utcOffset(), "minutes").format())}
							errorText={this.state.errorEndDate}
							errorStyle={{ position: "absolute", bottom: -10 }}
							cancelLabel={<span style={{ color: blueGrey500 }}>{strings.Cancel}</span>}
							firstDayOfWeek={0}
							disabled={this.props.readonly}
						/>
						<FontIcon
							data-intercom-target={"LeaveTracking-Btn-EndDatePicker"}
							className="fa fa-calendar"
							style={{ position: "absolute", top: 35, right: 10, fontSize: 21, color: "rgba(97, 97, 97, 0.6)" }}
							onClick={() => this.EndDate.DatePicker.openDialog()}
						/>
					</div>
				</div>
				{AccountStore.getPayRateTimeOffEditAllowed() &&
					<TextField
						data-intercom-target={"LeaveTracking-Entry-TimeOffPayRate"}
						type="number"
						floatingLabelText={strings.Pay_Rate}
						value={this.state.payRate}
						step={0.01}
						inputStyle={{ appearance: "auto" }}
						errorText={this.state.errorPayRate}
						errorStyle={{ position: "absolute", bottom: -20 }}
						onChange={(e, value) => this.setState({ payRate: Math.round(value * 100) / 100 }, () => this.checkValidate)}
						disabled={this.props.readonly}
					/>
				}
				<div style={{ display: "flex" }}>
					<TextField
						data-intercom-target={"LeaveTracking-Entry-Comments"}
						floatingLabelText={strings.Comments}
						value={this.state.comments}
						onChange={(e, value) => this.setState({ comments: value }, () => this.checkValidate())}
						style={{ width: "90%" }}
						disabled={this.props.readonly}
						errorText={this.state.errorComment}
					/>
				</div>
				<div style={{ marginTop: 10, display: "flex", justifyContent: "space-between", alignItems: "center", height: 53, position: "relative" }}>
					<div style={{ position: "absolute", top: 0, color: red500, fontSize: 12 }}>{this.state.errorSpecifyDays}</div>
					<Toggle
						data-intercom-target={"LeaveTracking-Toggle-SpecifyDays"}
						label={strings.Specify_Days}
						style={{ width: 175 }}
						toggled={this.state.enableSpecifyDays}
						onToggle={(e, enableSpecifyDays) => this.setState({ enableSpecifyDays, specifyDays: enableSpecifyDays ? this.state.specifyDays : [] }, () => this.checkValidate())}
						disabled={this.props.readonly}
					/>
					{this.state.enableSpecifyDays &&
						<SpecifyDays
							readonly={this.props.readonly}
							specifyDays={this.state.specifyDays}
							handleChange={specifyDays => this.setState({ specifyDays }, () => this.checkValidate())}
						/>
					}
				</div>
			</Dialog >
		)
	}
}
